import { useQuery } from "@apollo/client/react";
import { graphql, type ResultOf, type VariablesOf } from "@tucan/graphql";
import { COMPANY_SETTING_FRAGMENT } from "../fragment/company.setting.fragment";

const QUERY = graphql(`
  query getCompanySettingByName($name: String!, $company: ID!) {
    setting: getCompanySettingByName(name: $name, company: $company) {
      ...CompanySetting
    }
  }
`, [COMPANY_SETTING_FRAGMENT]);

type Data = ResultOf<typeof QUERY>;
type Variables = VariablesOf<typeof QUERY>;

export const useCompanySettingByNameQuery = (
  data: useQuery.Options<Data, Variables>,
): useQuery.Result<Data, Variables> => useQuery<Data, Variables>(QUERY, data);
